<template>
    <!-- TODO translate -->
    <FilterBase class="filter-metal">
        <FilterList>
            <FilterItemMetal
                v-for="metal in filter"
                :key="metal.metal.systemCode"
                :add-link="getRouteAddMetal(metal.metal.systemCode)"
                :filter="metal"
                :remove-link="getRouteRemoveMetal()"
                :selected="isSelected(fliterMapperMetal(metal))"
                :total-results="metal.totalResults"
                :disabled="disabled"
            />
        </FilterList>
    </FilterBase>
</template>

<script lang="ts" setup>
import type { MetalCode, MetalFilterFragment } from '@/graphql/api'
import { fliterMapperMetal } from '@/domain/product/ring/engagement'
import type { ButtonRouteRelative } from '@/components/ui/buttons/useThButton'

import FilterBase from '@/components/ui/filter/filters/layout/FilterBase.vue'
import FilterItemMetal from '../FilterItemMetal.vue'
import FilterList from './layout/FilterList.vue'

interface Props {
    filter: MetalFilterFragment[]
    selected?: MetalCode[]
    getRouteAddMetal: (metal: MetalCode) => ButtonRouteRelative
    getRouteRemoveMetal: () => ButtonRouteRelative
    disabled?: boolean
}

const props = withDefaults(defineProps<Props>(), {
    selected: () => [],
})

const isSelected = (item: MetalCode) => props.selected.includes(item)
</script>
